import React from 'react';
import { motion } from 'framer-motion';
// All illustrations are inline SVG → zero network requests, instant render, crisp at any size.
const illustrations: Record<string, JSX.Element> = {
  B1: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-32">
      <rect x="8" y="14" width="44" height="32" rx="6" fill="#C8A664" data-id="element-33" />
      <circle cx="20" cy="30" r="2.5" fill="#0F1B3D" data-id="element-34" />
      <circle cx="30" cy="30" r="2.5" fill="#0F1B3D" data-id="element-35" />
      <circle cx="40" cy="30" r="2.5" fill="#0F1B3D" data-id="element-36" />
      <path d="M18 46l-4 8 10-4z" fill="#C8A664" data-id="element-37" />
      <rect x="30" y="34" width="44" height="30" rx="6" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-38" />
      <line x1="38" y1="44" x2="62" y2="44" stroke="#0F1B3D" strokeWidth="2" strokeLinecap="round" data-id="element-39" />
      <line x1="38" y1="50" x2="56" y2="50" stroke="#0F1B3D" strokeWidth="2" strokeLinecap="round" data-id="element-40" />
      <line x1="38" y1="56" x2="60" y2="56" stroke="#0F1B3D" strokeWidth="2" strokeLinecap="round" data-id="element-41" />
      <path d="M62 64l4 7-10-3z" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-42" />
    </svg>,
  B2: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-43">
      <circle cx="28" cy="40" r="14" stroke="#C8A664" strokeWidth="4" fill="none" data-id="element-44" />
      <circle cx="28" cy="40" r="4" fill="#C8A664" data-id="element-45" />
      <rect x="40" y="36" width="32" height="8" fill="#C8A664" data-id="element-46" />
      <rect x="60" y="44" width="6" height="6" fill="#C8A664" data-id="element-47" />
      <rect x="68" y="44" width="4" height="10" fill="#C8A664" data-id="element-48" />
      <path d="M20 18c0-4 4-8 8-8s8 4 8 8" stroke="#FAF7F2" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-49" />
      <circle cx="28" cy="22" r="2" fill="#FAF7F2" data-id="element-50" />
    </svg>,
  B3: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-51">
      <rect x="14" y="14" width="36" height="46" rx="3" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-52" />
      <rect x="22" y="22" width="40" height="46" rx="3" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-53" />
      <rect x="30" y="30" width="40" height="46" rx="3" fill="#C8A664" data-id="element-54" />
      <line x1="36" y1="40" x2="62" y2="40" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" data-id="element-55" />
      <path d="M37 50l3 3 6-7" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-56" />
      <line x1="50" y1="50" x2="62" y2="50" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" data-id="element-57" />
      <path d="M37 60l3 3 6-7" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-58" />
      <line x1="50" y1="60" x2="62" y2="60" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" data-id="element-59" />
    </svg>,
  B4: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-60">
      <path d="M40 8l26 8v22c0 16-12 28-26 34C26 66 14 54 14 38V16l26-8z" fill="#C8A664" data-id="element-61" />
      <path d="M40 24v18" stroke="#0F1B3D" strokeWidth="5" strokeLinecap="round" data-id="element-62" />
      <circle cx="40" cy="52" r="3" fill="#0F1B3D" data-id="element-63" />
      <circle cx="62" cy="22" r="6" fill="#DC2626" data-id="element-64" />
      <text x="62" y="26" textAnchor="middle" fontSize="9" fontWeight="bold" fill="#FAF7F2" data-id="element-65">
        !
      </text>
    </svg>,
  B5: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-66">
      <path d="M14 36L40 16l26 20v28a4 4 0 01-4 4H18a4 4 0 01-4-4V36z" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2.5" data-id="element-67" />
      <circle cx="30" cy="48" r="5" fill="#C8A664" data-id="element-68" />
      <circle cx="50" cy="48" r="5" fill="#C8A664" data-id="element-69" />
      <circle cx="40" cy="44" r="6" fill="#0F1B3D" data-id="element-70" />
      <path d="M22 64c0-5 4-8 8-8s8 3 8 8" stroke="#C8A664" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-71" />
      <path d="M42 64c0-5 4-8 8-8s8 3 8 8" stroke="#C8A664" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-72" />
      <path d="M32 60c0-5 4-8 8-8s8 3 8 8" stroke="#0F1B3D" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-73" />
    </svg>,
  B6: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-74">
      <rect x="10" y="14" width="60" height="50" rx="4" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2.5" data-id="element-75" />
      <path d="M14 30 Q26 22 38 30 T62 30" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 3" fill="none" data-id="element-76" />
      <path d="M18 46 Q30 38 42 46 T66 44" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 3" fill="none" data-id="element-77" />
      <circle cx="20" cy="26" r="4" fill="#0F1B3D" data-id="element-78" />
      <circle cx="40" cy="40" r="4" fill="#C8A664" data-id="element-79" />
      <circle cx="62" cy="54" r="5" fill="#DC2626" data-id="element-80" />
      <path d="M60 52l2 2 4-5" stroke="#FAF7F2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-81" />
    </svg>
};
const bonuses = [{
  number: 'B1',
  title: 'Guión de la primera conversación',
  description: 'Frases listas para abrir el vínculo desde el primer encuentro.'
}, {
  number: 'B2',
  title: '80 preguntas que abren puertas',
  description: 'Banco de preguntas por momento del proceso, listo para usar.'
}, {
  number: 'B3',
  title: 'Kit de fichas listas para usar',
  description: 'Registros y checklists imprimibles. Descargás e imprimís.'
}, {
  number: 'B4',
  title: 'Protocolo de emergencia en recaída',
  description: 'Qué hacer en las primeras 48 horas, paso a paso.'
}, {
  number: 'B5',
  title: 'Cómo explicarle a la familia',
  description: 'Guía accesible para que el entorno acompañe sin empeorar.'
}, {
  number: 'B6',
  title: 'Mapa visual del proceso completo',
  description: 'Infografía del recorrido del primer contacto al cierre.'
}];
export function Bonuses() {
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-82">
      <div className="max-w-2xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-8" data-id="element-84">
          <div className="inline-block bg-green-100 text-green-800 px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold mb-2 md:mb-3" data-id="element-85">
            INCLUIDOS GRATIS
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-1 md:mb-2" data-id="element-86">
            6 Bonos Estratégicos
          </h2>
          <p className="text-sm md:text-base text-gray-700" data-id="element-87">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </motion.div>

        <div className="space-y-2 md:space-y-2.5 mb-5 md:mb-6" data-id="element-88">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04
        }} whileHover={{
          x: 3
        }} className="group bg-cream-light rounded-lg border border-gold/20 hover:border-gold/60 hover:shadow-md transition-all relative flex items-stretch overflow-hidden cursor-default" data-id="element-89">
              <div className="flex-shrink-0 w-14 md:w-20 bg-navy-dark flex flex-col items-center justify-center relative px-1" aria-hidden="true" data-id="element-90">
                <div className="absolute inset-0 bg-gradient-radial from-gold/20 to-transparent" data-id="element-91" />
                <div className="w-9 h-9 md:w-12 md:h-12 relative z-10" data-id="element-92">
                  {illustrations[bonus.number]}
                </div>
                <div className="font-serif text-[9px] md:text-xs font-bold text-gold mt-0.5 relative z-10 leading-none" data-id="element-93">
                  {bonus.number}
                </div>
              </div>

              <div className="flex-1 py-2 md:py-3 px-3 md:px-4 pr-12 md:pr-16 flex flex-col justify-center" data-id="element-94">
                <h3 className="font-bold text-navy-dark text-xs md:text-sm leading-tight mb-0.5" data-id="element-95">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-[10px] md:text-xs leading-snug" data-id="element-96">
                  {bonus.description}
                </p>
              </div>

              <span className="absolute top-1.5 md:top-2 right-1.5 md:right-2 bg-green-600 text-white text-[8px] md:text-[10px] font-bold px-1.5 md:px-2 py-0.5 rounded-full leading-none" data-id="element-97">
                GRATIS
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-gold/10 border-2 border-gold p-2.5 md:p-4 rounded-lg text-center" data-id="element-98">
          <p className="font-bold text-navy-dark text-xs md:text-base" data-id="element-99">
            VALOR TOTAL DE LOS BONOS: $47.000 — GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}